import About from '../views/About.vue'
import Home from '../views/Home.vue'
import Explore from '../views/Explore.vue'

const routes = [
  
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/explore',
    name: 'Explore',
    component: Explore
  },
]

export default routes
